export default "__VITE_ASSET__DvjkzqZz__"